import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import type { ApiResponse } from '../../shared/models/response';
import type { Tag } from '../../shared/store/reducers/tags.reducer';

@Injectable({
  providedIn: 'root',
})
export class TagsService {
  readonly #http = inject(HttpClient);

  getTags(): Observable<ApiResponse<Tag[]>> {
    return this.#http.get<ApiResponse<Tag[]>>(
      `${environment.api.endpoint}/tags`,
    );
  }
}
